import React from 'react';
import { AssessmentsAuthentication } from 'components/AssessmentsAuthentication/AssessmentsAuthentication';
import { AssessmentsErrorState } from 'components/AssessmentsErrorState/AssessmentsErrorState';
import { FullScreenLoader } from 'components/FullScreenLoader/FullScreenLoader';
import { useAssessmentsAuthConfig } from 'features/assessments/hooks/useAssessmentsAuthConfig';
import { AssessmentsNotFound } from 'components/AssessmentsNotFound/AssessmentsNotFound';

export const UnauthenticatedAssessmentsVerify = () => {
  const { authenticationFields, fetchingAuthConfig, error, refetch, isShowNotFound } =
    useAssessmentsAuthConfig();

  if (fetchingAuthConfig) {
    return <FullScreenLoader />;
  }
  if (isShowNotFound) {
    return <AssessmentsNotFound hideBackHomeButton />;
  }
  if (error) {
    return <AssessmentsErrorState onRetryClick={refetch} />;
  }

  return <AssessmentsAuthentication fields={authenticationFields ?? []} />;
};
